import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToInfo = () => {
    const element = document.getElementById('que-incluye');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative flex items-center justify-center overflow-x-hidden pt-12 sm:pt-20 pb-3 min-h-[65vh] sm:min-h-[85vh]" data-id="element-97">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-98">
        <img src="https://cdn.magicpatterns.com/uploads/13XwinoxGPs9eGt4m2qEvB/20260306_0039_Image_Generation_simple_compose_01kk0kmhqne1srye5dvx6t7rbb.png" alt="Proyecto Organizacional" className="w-full h-full object-cover object-center" data-id="element-99" />
        {/* Gradient Overlay: 70% bottom → 35% top */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/95 via-[#0a1628]/70 to-[#0a1628]/55" data-id="element-100"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-3 sm:px-6 text-center flex flex-col items-center" data-id="element-101">
        {/* Badge */}
        <div className="inline-block bg-[#fbbf24]/30 backdrop-blur-sm text-white px-2 py-1 rounded-full sm:text-sm mb-1.5 border border-[#fbbf24]/50 text-[9px] sm:text-[12px] font-[600] leading-snug text-center whitespace-nowrap" data-id="element-102">
          ⭐ El recurso #1 para docentes de Proyecto Organizacional ⭐
        </div>

        {/* H1 Title */}
        <h1 className="text-lg sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-1 px-1" style={{
        textShadow: '0 2px 8px rgba(0,0,0,0.7), 0 4px 20px rgba(0,0,0,0.5)'
      }} data-id="element-103">
          Resolvé todo tu año de Proyecto Organizacional en un solo lugar y dejá
          de planificar desde cero
        </h1>

        {/* Recursos Completos Badge */}
        <p className="text-[#fbbf24] text-base sm:text-2xl font-bold mb-1.5 drop-shadow-lg" data-id="element-104">
          Recursos completos.
        </p>

        {/* Product Mockup */}
        <div className="w-full max-w-[280px] sm:max-w-md md:max-w-lg mb-1.5 cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-105">
          <img src="https://cdn.magicpatterns.com/uploads/5LvaVTxvwXvr9CboH6Fy84/conjunto_de_mockups_proyecto_organizacional.png" alt="Kit Completo Proyecto Organizacional Lista" className="w-full h-auto drop-shadow-2xl animate-float" data-id="element-106" />
        </div>

        {/* Subtitle */}
        <p className="text-xs sm:text-lg text-gray-200 max-w-2xl mx-auto mb-2 font-medium leading-relaxed drop-shadow-md px-1" data-id="element-107">
          📚 Diseñado por docentes para docentes de secundaria que enseñan
          gestión, organizaciones y proyectos, para que ahorres meses de
          preparación y tengas tus clases listas para aplicar desde el primer
          día.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto" data-id="element-108">
          <button onClick={scrollToOffer} className="flex items-center justify-center bg-[#dc2626] hover:bg-red-700 text-white text-sm sm:text-lg font-bold py-2.5 px-6 rounded-lg shadow-[0_4px_14px_0_rgba(220,38,38,0.5)] transition-all transform hover:-translate-y-1 w-full sm:w-auto border-b-4 border-red-900 active:border-b-0 active:translate-y-0" data-id="element-109">
            Adquirir Ahora <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" data-id="element-110" />
          </button>

          <button onClick={scrollToInfo} className="flex items-center justify-center bg-transparent hover:bg-white/10 text-white border-2 border-white/40 text-sm sm:text-lg font-semibold py-2.5 px-6 rounded-lg transition-all w-full sm:w-auto backdrop-blur-sm" data-id="element-111">
            Más Información
          </button>
        </div>
      </div>
    </section>;
}